<div
  class="card"
  [id]="challenge().offerId"
  [style.boxShadow]="config().boxShadow ? config().boxShadow : ''"
>
  <!-- Decorative background: the title and subtitle below are real text, so no
  `role="img"` here — it would hide them from assistive technology -->
  <div
    class="card-header"
    [style]="{
      height: config().header.height,
      backgroundImage: config().header.backgroundImage.url | transformUrl,
    }"
  >
    <!-- Header Title -->
    <div class="header-details">
      @let headerTitle = config().header.backgroundImage.title;
      @if (headerTitle) {
        <p
          class="title"
          [style.color]="headerTitle.color"
          [style.fontFamily]="headerTitle.fontFamily"
        >
          {{ headerTitle.text | replaceVars: challenge().target }}
        </p>
      }

      <!-- Header Subtitle -->
      @let headerSubtitle = config().header.backgroundImage.subTitle;
      @if (headerSubtitle) {
        <p
          class="sub-title"
          [style.color]="headerSubtitle.color"
          [style.fontFamily]="headerSubtitle.fontFamily"
        >
          {{ headerSubtitle.text }}
        </p>
      }
    </div>
  </div>

  <!-- Card SubHeader -->
  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    <!-- Subheader Title -->
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <p
        class="label"
        [style.color]="labelConfig.color"
        [style.fontFamily]="labelConfig.fontFamily"
      >
        {{
          labelConfig.label | replaceVars: challenge().minAmountByTransaction
        }}
      </p>
    }
  </div>

  <div
    class="card-content"
    data-variant="variant_12"
    data-cy="frequency-card-content"
  >
    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }

    @if (challenge().isSelected && challenge().progress < challenge().target) {
      <!-- Card Body -->
      <div class="card-body">
        <!-- Steps < 5 -->
        @let steps = challenge().steps;
        @if (steps.length <= 5) {
          @let stamps = config().body.stamps;
          <div class="items" data-cy="stamps">
            @for (step of steps; track $index) {
              <div class="item">
                @if (stamps) {
                  <img
                    alt=""
                    width="40"
                    height="40"
                    data-cy="stamp"
                    class="responsive-width"
                    [ngSrc]="
                      step <= challenge().progress
                        ? stamps.iconSelected
                        : stamps.iconNonSelected
                    "
                  />
                }
                @if (stamps?.showNumbers) {
                  <span
                    class="number"
                    [class.active]="step <= challenge().progress"
                    aria-hidden="true"
                  >
                    {{ step }}
                  </span>
                }
              </div>
            }
            @let bodyRewardRatio = config().body.rewardRatio;
            @if (bodyRewardRatio) {
              <div
                class="reward-ratio"
                [style]="{
                  color: bodyRewardRatio.color,
                  fontFamily: bodyRewardRatio.fontFamily,
                }"
              >
                <img
                  width="50"
                  height="50"
                  [alt]="
                    bodyRewardRatio.rewardPicture.alternativeText
                      | replaceVars: challenge().rewardRatio
                  "
                  [ngSrc]="bodyRewardRatio.rewardPicture.imageUrl"
                />
                @if (config().splitCurrencyAmount) {
                  @let amountParts =
                    challenge().rewardRatio | formatAmountParts;
                  <span class="amount split-amount">
                    <span class="amount-currency">{{
                      amountParts.currency
                    }}</span>
                    <span class="amount-integer">{{
                      amountParts.integer
                    }}</span>
                    <span class="amount-fraction">{{
                      amountParts.fraction
                    }}</span>
                  </span>
                } @else {
                  <span class="amount">{{
                    challenge().rewardRatio | formatReward
                  }}</span>
                }
              </div>
            }
          </div>
        } @else {
          <div class="visits-container">
            @let visitsCounter = config().visitsCounter;
            <div class="item">
              <img
                alt=""
                width="55"
                height="55"
                [ngSrc]="visitsCounter.progress.imageUrl"
              />
              <span
                class="number"
                data-cy="progress"
                aria-hidden="true"
                [style]="{
                  color: visitsCounter.progress.color,
                  fontFamily: visitsCounter.progress.fontFamily,
                }"
                >{{ challenge().progress }}</span
              >
            </div>
            <span
              class="sign"
              aria-hidden="true"
              [style.backgroundColor]="visitsCounter.progress.color"
            ></span>
            <div
              class="item total"
              [style.backgroundColor]="visitsCounter.target.backgroundColor"
            >
              <span
                class="number"
                data-cy="target"
                aria-hidden="true"
                [style]="{
                  color: visitsCounter.target.color,
                  fontFamily: visitsCounter.target.fontFamily,
                }"
                >{{ challenge().target }}</span
              >
            </div>
            @let bodyRewardRatio = config().body.rewardRatio;
            @if (bodyRewardRatio) {
              <div
                class="reward-ratio"
                [style]="{
                  color: bodyRewardRatio.color,
                  fontFamily: bodyRewardRatio.fontFamily,
                }"
              >
                <img
                  width="60"
                  height="60"
                  [alt]="
                    bodyRewardRatio.rewardPicture.alternativeText
                      | replaceVars: challenge().rewardRatio
                  "
                  [ngSrc]="bodyRewardRatio.rewardPicture.imageUrl"
                />
                @if (config().splitCurrencyAmount) {
                  @let amountParts =
                    challenge().rewardRatio | formatAmountParts;
                  <span class="amount split-amount">
                    <span class="amount-currency">{{
                      amountParts.currency
                    }}</span>
                    <span class="amount-integer">{{
                      amountParts.integer
                    }}</span>
                    <span class="amount-fraction">{{
                      amountParts.fraction
                    }}</span>
                  </span>
                } @else {
                  <span class="amount">{{
                    challenge().rewardRatio | formatReward
                  }}</span>
                }
              </div>
            }
          </div>
        }
      </div>

      <!-- Card Footer: deactivate (or the challenge status once a visit is
      registered) on one side, the visits left on the other -->
      <div class="card-footer">
        @if (canUnselect()) {
          <b2c-unselection-button
            [phase]="phase()"
            [challenge]="challenge()"
            class="unselect-challenge"
            [isBisCampaign]="isBisCampaign()"
            [isEventChallenge]="isEventChallenge()"
          />
        } @else {
          <p
            class="label"
            [style]="{
              color: config().footer.color,
              fontFamily: config().footer.fontFamily,
            }"
            [innerHTML]="config().footer.label | safe"
          ></p>
        }

        @let remainingVisitsLabel = config().footer.remainingVisitsLabel;
        <p
          class="remaining-visits"
          [style]="{
            color: remainingVisitsLabel.color,
            fontFamily: remainingVisitsLabel.fontFamily,
          }"
          [innerHTML]="
            remainingVisitsLabel.text | replaceVars: remainingVisits() | safe
          "
        ></p>
      </div>
    }

    <!-- Selection Button -->
    @if (!challenge().isSelected) {
      <div class="overlay">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          class="selection-button"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
